import * as React from "react";
import {
  goTo,
  githubDemo,
  spaceXDemo,
  graphqlJobsDemo,
  updateLocation,
} from "./utils";

export default function LandingPage({
  url,
  setEndpoint,
}: {
  url: string;
  setEndpoint: (str: string) => void;
}) {
  const [endpointInput, setEndpointInput] = React.useState(url);
  const [shadowVisible, setShadowVisible] = React.useState(false);
  const headingRef = React.useRef(null as unknown as HTMLDivElement);

  function updateEndpoint() {
    updateLocation(endpointInput);
    setEndpoint(endpointInput);
  }

  React.useEffect(
    function scrollObserver() {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setShadowVisible(false);
          else setShadowVisible(true);
        },
        {
          root: null,
          rootMargin: "-10px",
          threshold: 1,
        }
      );
      if (headingRef.current) {
        observer.observe(headingRef.current);
      }

      return () => {
        observer.disconnect();
      };
    },
    [headingRef]
  );

  return (
    <div className="landing-page-holder">
      <header className={shadowVisible ? "header-shadow" : ""}>
        <div className="header-content">
          <a href="/">
            <img
              className="logo"
              src="data:image/svg+xml;base64,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"
              alt="Hasura Logo"
              title="Hasura Logo"
            />
          </a>
          <a className="ml-auto" href="/">
            <button
              className="outline btn"
              onClick={() => goTo(window.location.origin)}
            >
              Create Your API with Hasura Cloud
            </button>
          </a>
        </div>
      </header>
      <div ref={headingRef} />
      <div className="container">
        <div className="text-center mb-lg">
          <h1>Explore your GraphQL API</h1>
          <h2 className="muted">Test your API with GraphiQL and Hasura</h2>
        </div>
        <div className="onboarding-card mb-lg">
          <div className="left-card">
            <div className="left-info">
              <p className="flex items-center white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="fill-green icn mr-xs"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Explore with a visual explorer and documentation.
              </p>
              <p className="flex items-center white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="fill-green icn mr-xs"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Test your queries, mutations, and subscriptions.
              </p>
              <p className="flex items-center white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="fill-green icn mr-xs"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Modify your headers and test your permissions.
              </p>
            </div>
            <div className="left-api">
              <p className="strong white mb-sm">
                Need an API to test? Try one of these public APIs:
              </p>

              <div
                onClick={() => goTo(githubDemo)}
                className="flex items-center picker-card mb-md white move-on-hover"
              >
                <div>
                  <p>GitHub</p>
                  <p className="small muted-o">
                    Queryable GitHub repo information
                  </p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="ml-auto icn mr-xs"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </div>

              <div
                onClick={() => goTo(spaceXDemo)}
                className="flex items-center picker-card mb-md white move-on-hover"
              >
                <div>
                  <p>SpaceX</p>
                  <p className="small muted-o">The public SpaceX mission log</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="ml-auto icn mr-xs"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </div>
              <div
                onClick={() => goTo(graphqlJobsDemo)}
                className="flex items-center picker-card white move-on-hover"
              >
                <div>
                  <p>GraphQL Jobs</p>
                  <p className="small muted-o">A GraphQL API of GraphQL jobs</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="ml-auto icn mr-xs"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="right-card">
            <p className="white mb-sm">
              Just enter your endpoint URL, no sign-up required.
            </p>
            <input
              className="url-input mb-sm"
              placeholder="GraphQL Endpoint URL..."
              value={endpointInput}
              onChange={(e) => setEndpointInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  updateEndpoint();
                }
              }}
            />
            <button className="btn connect mb-md" onClick={updateEndpoint}>
              Connect to Endpoint
            </button>
          </div>
        </div>
        <div className="hasuras-footer mb-lg">
          <img
            alt=""
            src="https://hasura.io/static/footer-img-79b3cfc0ceb3c7e466198ae09e1d4e6e.png"
          />
        </div>
        <footer className="flex items-center">
          <div className="flex items-center items-center">
            <img
              className="logo-sm mr-md"
              src="data:image/svg+xml;base64,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"
              alt="Hasura Logo"
              title="Hasura Logo"
            />
            <a className="muted mt-2px" href="https://www.hasura.io">
              <p className="small flex items-center">
                Back to Hasura.io
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="ml-xs icn-sm"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </p>
            </a>
          </div>

          <div className="ml-auto flex items-center">
            <p className="muted small">
              © 2021 Hasura Inc. All rights reserved
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}
